import type {ReactElement} from 'react';
import React from 'react';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {rgbToHexString} from '@Utils/color.util';
import type {ColorFillOption} from '@Components/poster-editor/components/poster-editing-side-panel/poster-editing-side-panel.types';
import {COLOR_OBJECT_IDS} from '@Components/poster-editor/components/poster-editing-side-panel/poster-editing-side-panel.types';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromFancyTextItem} from '@Hooks/poster-editor/useGetKeyFromFancyTextItem';

interface FancyTextColorOptionProps {
  onClickColorFill(colorId: ColorFillOption): void;
}

export function FancyTextColorOption({...props}: FancyTextColorOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemColors = useGetKeyFromFancyTextItem('colors');

  if (!activeItem) {
    throw new Error('Active item does not exist');
  }

  if (!activeItem.isFancyText() || !activeItemColors) {
    throw new Error(`Expected Active item to be of type fancy text, instead got ${activeItem.gitype}`);
  }

  const onClick = (id: ColorFillOption): void => {
    props.onClickColorFill(id);
  };

  const getColorObject = (): ColorFillStorage[] => {
    const colorStorage: ColorFillStorage[] = [];
    for (let index = 0; index < activeItemColors.length; index += 1) {
      colorStorage.push({
        id: COLOR_OBJECT_IDS[index],
        color: [
          {
            id: `color-${COLOR_OBJECT_IDS[index]}`,
            color: activeItemColors[index],
          },
        ],
      });
    }

    return colorStorage;
  };

  return <ContextualMenuColorFillOption id="fancy-text-color-option" label={window.i18next.t('pmwjs_color')} data={getColorObject()} onClick={onClick} />;
}
